export const currentScriptSrc = () => document.location.origin + '/app/'
